module.exports = __webpack_public_path__ + "fonts/icomoon.ad0f3ba.ttf";